import { gql } from "@apollo/client";

export const GET_ACTIVE_SESSIONS = gql`
  query ActiveSessions($searchText: String, $skip: Int!, $take: Int!) {
    ActiveSessions(searchText: $searchText, skip: $skip, take: $take) {
      totalCount
      sessions {
        _id
        userId
        userName
        userEmail
        companyName
        userAgent
        ip
        loginAt
        lastActivityAt
      }
    }
  }
`;

export const GET_EXPIRED_SESSIONS = gql`
  query ExpiredSessions($searchText: String, $skip: Int!, $take: Int!) {
    ExpiredSessions(searchText: $searchText, skip: $skip, take: $take) {
      totalCount
      sessions {
        _id
        userId
        userName
        userEmail
        companyName
        loginAt
        lastActivityAt
        revokedAt
        revokedReason
      }
    }
  }
`;
